const STORAGE_KEY = 'athlete-invoice-view-state';

export interface InvoiceViewState {
  visible: Record<string, number>;
  scrollTop: number;
}

const emptyState = (): InvoiceViewState => ({ visible: {}, scrollTop: 0 });

export const readInvoiceViewState = (): InvoiceViewState | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as InvoiceViewState) : null;
  } catch {
    return null;
  }
};

const write = (state: InvoiceViewState): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {}
};

export const saveVisibleCount = (bucketKey: string, count: number): void => {
  const state = readInvoiceViewState() ?? emptyState();
  write({ ...state, visible: { ...state.visible, [bucketKey]: count } });
};

export const saveScrollTop = (scrollTop: number): void => {
  const state = readInvoiceViewState() ?? emptyState();
  write({ ...state, scrollTop });
};

export const clearInvoiceViewState = (): void => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {}
};
